import { fetcherModeAtom } from "@keepeek/commons";
import { useRecoilValue, useRecoilValueLoadable } from "recoil";

import { textTemplatingFetcherSelector } from "../fetcher/selectors/textTemplating";

export const useTextTemplating = (): {
  loading: boolean;
  evaluate: (text: string) => string;
} => {
  const mode = useRecoilValue(fetcherModeAtom);
  const textFetcherQuery = useRecoilValueLoadable(textTemplatingFetcherSelector(mode));

  return {
    loading: textFetcherQuery.state === "loading",
    evaluate:
      textFetcherQuery.state === "hasValue" ? textFetcherQuery.contents.evaluate : (text) => text,
  };
};
